import { Table, TablePaginationConfig, Tag } from 'antd'
import { useTranslation } from 'react-i18next'

import { DeviceDetail } from '@/types/apis/clientDevice/GetOneClientDeviceResponse'
import { formatHour, formatYMD } from '@/utils/date'

type Props = {
  dataSource: DeviceDetail[]
  loading: boolean
  page: number
  pageSize: number
  totalItems: number
  onChange: (config: TablePaginationConfig) => void
}

const DeviceErrorsTable = ({ dataSource, loading, onChange, page, pageSize, totalItems }: Props) => {
  const { t } = useTranslation()

  const columns = [
    {
      title: t('components.pages.clients.table.id'),
      dataIndex: 'id',
      key: 'id',
      render: (text: string, record: DeviceDetail, index: number) => <div>{index + 1}</div>,
    },
    {
      title: t('components.pages.clients.table.name'),
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: t('components.pages.clients.table.status'),
      dataIndex: 'status',
      key: 'status',
      // status = 0 then device is ON => OFF, status = 1 then device is OFF => ON
      render: (text: string, record: DeviceDetail) => (
        <Tag color={record.status === 1 ? 'green' : 'red'}>{record.status === 1 ? 'OFF -> ON' : 'ON -> OFF'}</Tag>
      ),
    },
    {
      title: t('components.pages.clients.table.date'),
      dataIndex: 'date',
      key: 'date',
      render: (text: string, record: DeviceDetail) => (
        <div>{`${formatYMD(record.createdAt)} ${formatHour(record.createdAt)}`}</div>
      ),
    },
  ]

  return (
    <Table
      rowKey="id"
      dataSource={dataSource}
      columns={columns}
      loading={loading}
      pagination={{
        pageSize,
        current: page,
        total: totalItems,
      }}
      onChange={onChange}
    />
  )
}
DeviceErrorsTable.displayName = 'DeviceErrorsTable'
export default DeviceErrorsTable
